import isURL from "./isURL";
import isEmail from "./isEmail";
import hasCustomVariableToken from "./hasCustomVariableToken";

export const getSanitizedUrl = value => {
  if (value === "") return "";

  if (isURL(value) && !hasCustomVariableToken(value)) {
    if (
      value.startsWith("http") ||
      value.startsWith("https") ||
      value.startsWith("mailto")
    ) {
      return value.replace(/ /g, "%20").trim();
    }
    return "http://".concat(value).replace(/ /g, "%20").trim();
  }

  return value.trim();
};

export const getSanitizedEmail = email => {
  if (email === "") return "";

  if (isEmail(email)) {
    return email.startsWith("mailto:")
      ? email.replace(/ /g, "%20").trim()
      : "mailto:".concat(email).replace(/ /g, "%20").trim();
  }

  return email.trim();
};

export const objectToQueryParams = params => {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .map(k =>
      !params[k] || params[k] === undefined || params[k].length === 0
        ? ""
        : `${esc(k)}=${esc(params[k])}`
    )
    .join("&");
};
